import styled from "styled-components";

import Flex, {IFlexProps} from "./Flex";
import Tag from "./Tag";
import { H1, Paragraph } from "./Typography";

const Hero = styled(Flex) <IFlexProps>`
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  padding-bottom: 2rem;
  width: 100%;

  h1 {
    margin-top: 0;
    margin-block-start: 0;
    margin-bottom: 2rem;
    &:last-child {
      margin-bottom: 0;
    }
  }

  p {
    font-size: 1.5rem;
    margin-bottom: 2.5rem;
    line-height: 125%;
    &:last-child {
      margin-bottom: 0;
    }
  }

  button {
    min-width: 10rem;
    height: 3rem;
    font-size: 1.25rem;
    margin-bottom: 2rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const HeroTag = styled(Tag)`
  background-color: transparent;
  padding: 0;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1.5rem;
  font-size: 1.25rem;
  letter-spacing: 0.15rem;
`;
export const HeroTitle = H1;
export const HeroText = Paragraph;

export default Hero;
